import { FC } from "react";
import { AxiosError } from "axios";
import { HStack, Stack, Text } from "@chakra-ui/react";

import { ErrorTechInfoId } from "./ErrorTechInfoId";
import { ErrorTechInfoCode } from "./ErrorTechInfoCode";

interface Props {
  error?: Error | null;
  bgColor?: "white" | "gray";
}

export const ErrorTechInfo: FC<Props> = ({ error, bgColor }) => {
  const err = error as AxiosError<{ code?: string } | undefined> | null;

  const code = err?.response?.data?.code;
  const id = (err?.response?.headers["x-call-id"] as string || "").slice(0, 8);

  const containerBgColor = bgColor === "white" ? "white" : "gray.50";
  const childBgColor = containerBgColor === "white" ? "gray.50" : "white";

  if (!code && !id) {
    return null;
  }

  return (
    <Stack
      w="100%"
      mt="6px"
      p="20px"
      spacing={0}
      borderRadius="16px"
      backgroundColor={containerBgColor}
    >
      <Text variant="brand" mt="1px" mb="15px" fontSize="14px" lineHeight="18px">
        Информация для технической поддержки, если проблема не исчезнет
      </Text>

      <HStack spacing="2px" justifyContent="space-between" flexWrap="wrap">
        <ErrorTechInfoCode code={code} bgColor={childBgColor} />
        <ErrorTechInfoId id={id} bgColor={childBgColor} />
      </HStack>
    </Stack>
  );
};
